<template>
  <div v-on="$listeners">
    <b-card
      :border-variant="borderVariant"
      :class="cardClasses"
    >
      <b-card-title
        :class="titleClass"
      >
        <slot name="card-title">
          <h3>{{ title }}</h3>
        </slot>
        <feather-icon
          v-if="canCollapse"
          class="ml-2 card-collapse__collapse-icon"
          :icon="collapseCard ? 'ChevronUpIcon' : 'ChevronDownIcon'"
          size="25"
          @click="collapseCard = !collapseCard"
        />
        <div v-else />
      </b-card-title>
      <b-collapse
        v-model="collapseCard"
        @show="$emit('show')"
      >
        <b-card-text class="mt-1">
          <slot />
        </b-card-text>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardText, BCollapse,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCollapse,
    BCard,
    BCardTitle,
    BCardText,
  },
  props: {
    borderVariant: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: 'd-flex justify-content-between',
    },
    title: {
      type: String,
      default: '',
    },
    canCollapse: {
      type: Boolean,
      default: true,
    },
    cardClasses: {
      type: String,
      default: '',
    },
  },
  setup() {
    const collapseCard = ref(false)

    return {
      collapseCard,
    }
  },
}
</script>

<style scoped>
.card-collapse__collapse-icon {
    cursor: pointer;
}
.card-body {
  padding:15px 20px;
}
.card-title {
  margin-bottom:0;
}
</style>
